module.exports = __webpack_public_path__ + "static/img/qq_3.0794e91f.png";